import Model from './model';

export default class LogicBaseConversation extends Model {
  constructor(_id, createdTime, updatedTime, key, participants, readTime) {
    super();
    this._id = _id;
    this.createdTime = createdTime;
    this.updatedTime = updatedTime
    this.key = key;
    this.participants = participants;
    this.readTime = readTime;
  }
  getJson = () => {
    const { _id, readTime } = this;
    return {
      _id,
      rt: readTime
    }
  }
}
